export class AgencyAddressModel {
  agencyName: string;
  phone: string;
  formattedPhoneNumber: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  zip: string;
}
